import { HttpErrorResponse } from '@angular/common/http';
import { EntityActions } from '../global-entities/global-enums';

export class ListRequest {
  public PageNumber = 1;
  public PageSize = 25;
  public OrderBy?: string;
}

export class NodeListSearch {
  propertyId: number[];
  where?: string;
  limit?: number;
  offset = 0;
  order?: string;
  language?: string[];
}

export class FileAssetRequest {
  public FileAssetId?: number;
  public FileName: string;
  public FilePayload: string;
  public Action: EntityActions;
  public PropertyId?: number;
}

export class FileUploadRequest<T = any> {
  public url: string;
  public files: File[];
  public onError: (error: HttpErrorResponse) => void;
  public onProgress: (value: number) => void;
  public onSuccess: (response: T) => void;
}

export class StaffAssignmentFilter {
  public PropertyId: number;
  public DepartmentID: number;
  public IncludeAllStaff: boolean;
  public AllPropertyCallCount: boolean;
}

export class StaffFilter {
  public Keyword = '';
  public selectedSkillList: number;
  public Departments: number;
  public Designations: number;
  public Skills?: number;

  public get HasFilter() {
    if (
      this.Departments ||
      this.Designations ||
      this.Skills ||
      this.Keyword !== ''
    ) {
      return true;
    }
    return false;
  }
}

export class StaffWOCountModel {
  StaffIds: number[];
  PropertyId: number;
}
